let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("h1h91")).then(() => parcelRequire('kz5fq'));